import React from 'react';
import { Button, Popover } from 'rsuite';

export type ButtonsCompetitorPriceProps = {
  className?: string;
  style?: React.CSSProperties;
  handleCalculoCompetitiviness: () => void;
  handleCalculoPreco: () => void;
  classNamecompetitor?: string;
};

export const ButtonsCompetitorPrice = ({
  className,
  style,
  handleCalculoCompetitiviness,
  handleCalculoPreco,
  classNamecompetitor,
}: ButtonsCompetitorPriceProps) => (
  <Popover className={`popover-competitors ${className}`} style={style}>
    <div className={classNamecompetitor}>
      <Button className="competitor-button" onClick={handleCalculoCompetitiviness}>
        Copiar preço concorrente
      </Button>
      <Button className="competitor-button" onClick={handleCalculoPreco}>
        Sugerir este preço
      </Button>
    </div>
  </Popover>
);
